import React, { PureComponent } from "react";
import { Form, Row, Col, Divider } from "antd";
import PhoneNumberMask from "../../../../../../common/inputs/AuthorizationInputs";

import "./forms.css";

import {
  SubjectId,
  Customer,
  PhoneCode,
  Email,
  Website,
  Inn,
  Ogrnip,
  UrAddress,
  DateRegistered,
  BankName,
  Bik,
  Сorrespondent,
  BankAccount
} from "./fieldsConfig";

class RequisitesFormIP extends PureComponent {
  render() {
    let { company, request } = this.props;
    let getFieldDecorator = this.props.decorator;
    return (
      <div className="requestCardForm">
        <Form>
          <Row
            type="flex"
            align="middle"
            className="formRow mb-large"
            gutter={16}
          >
            <Col span={6} className="formCol right">
              <span className="label">Субъект заказчика:</span>
            </Col>
            <Col className="formCol">
              <SubjectId
                val={company.subjectId.subject}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Наименование:</span>
            </Col>
            <Col span={12} className="formCol">
              <Customer
                val={company.nameLegal}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Адрес:</span>
            </Col>
            <Col span={12} className="formCol">
              <UrAddress
                val={company.addressLegal}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Дата регистрации:</span>
            </Col>
            <Col span={12} className="formCol">
              <DateRegistered
                val={
                  company.registratonDate
                    ? new Date(company.registratonDate).toLocaleDateString()
                    : "Не указано"
                }
                decorator={getFieldDecorator}
                classes="short"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">ИНН:</span>
            </Col>
            <Col span={12} className="formCol">
              <Inn
                val={company.inn}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Row
            type="flex"
            align="middle"
            className="formRow mb-large"
            gutter={16}
          >
            <Col span={6} className="formCol right">
              <span className="label">ОГРНИП:</span>
            </Col>
            <Col span={12} className="formCol">
              <Ogrnip
                val={company.ogrnip}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Номер телефона:</span>
            </Col>
            <Col span={12} className="formCol">
              <PhoneCode
                val={company.phoneCode}
                decorator={getFieldDecorator}
                classes="small mr"
                disabled
              />
              <PhoneNumberMask
                autoComplete="off"
                className="short"
                name="phone"
                mask="(###) ###-##-##"
                value={company.phone}
                maxLength={15}
                disabled
              />
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">E-mail:</span>
            </Col>
            <Col span={12} className="formCol">
              <Email
                val={
                  request && request.profileId && request.profileId.userId
                    ? request.profileId.userId.email
                    : company.email
                    ? company.email
                    : null
                }
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          {company.site && (
            <Row type="flex" align="middle" className="formRow" gutter={16}>
              <Col span={6} className="formCol right">
                <span className="label">Сайт:</span>
              </Col>
              <Col span={12} className="formCol">
                <Website
                  val={company.site}
                  decorator={getFieldDecorator}
                  classes="long"
                  disabled
                />
              </Col>
            </Row>
          )}
          {company.bankAccount &&
            company.bankAccount.map((item, index) => (
              <div key={"bankAccount" + index}>
                <Divider />
                <Row
                  type="flex"
                  align="middle"
                  className="formRow mg-"
                  key={"bankName" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">Наименование банка:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    <BankName
                      val={item.bankName}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="long"
                      disabled
                    />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  align="middle"
                  className="formRow"
                  key={"bik" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">БИК:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    <Bik
                      val={item.bik}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="short"
                      disabled
                    />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  align="middle"
                  className="formRow"
                  key={"accountCorr" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">Корреспондентский счет:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    {/* eslint-disable-next-line react/jsx-pascal-case */}
                    <Сorrespondent
                      val={item.accountCorr}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="short"
                      disabled
                    />
                  </Col>
                </Row>
                <Row
                  type="flex"
                  align="middle"
                  className="formRow"
                  key={"bankAccountNum" + index}
                  gutter={16}
                >
                  <Col span={6} className="formCol right">
                    <span className="label">Расчетный счет:</span>
                  </Col>
                  <Col span={12} className="formCol">
                    <BankAccount
                      val={item.bankAccountNum}
                      index={index}
                      decorator={getFieldDecorator}
                      classes="short"
                      disabled
                    />
                  </Col>
                </Row>
              </div>
            ))}
        </Form>
      </div>
    );
  }
}

export default RequisitesFormIP;
